<input id="range-ctrl" #rangeControl type="range" min="0" [max]="maxValue" [value]="value" (input)="sliderChange()" />
